import { ColumnConfig } from '../base-column/column.model';
import { ColumnClassProperties } from '../common-models/class.model';
import {
  initFromConfigButton,
  initFromPropsButtons,
} from '../common-models/init-functions';
import { styleProperties } from '../common-models/style.model';
import { ButtonColumn } from './button-column.model';

export class ActionButton<T> extends ButtonColumn<T> {
  constructor(config: ColumnConfig<T>);
  constructor(
    title?: string,
    action?: (item?: T, event?: any) => any,
    styleClass?: string | ((item?: any) => string),
    style?: styleProperties
  );
  constructor(
    titleOrConfig?: ColumnConfig<T> | string,
    action?: (item?: T, event?: any) => any,
    styleClass?: string | ((item?: any) => string),
    style?: styleProperties
  ) {
    super();
    if (typeof titleOrConfig === 'object') {
      const config = titleOrConfig as ColumnConfig<T>;
      initFromConfigButton(this, config);
    } else {
      initFromPropsButtons(
        this,
        titleOrConfig,
        undefined,
        styleClass,
        style,
        undefined,
        undefined,
        action
      );
    }
  }

  GetButtonClass(): ColumnClassProperties {
    return this.ColumnClassProperties ?? {};
  }

  GetButtonAction(row?: T, event?: any): any {
    if (this.Action) {
      if (row) {
        if (event) {
          return this.Action(row, event);
        }
        return this.Action(row);
      }
      return this.Action();
    } else {
      throw new Error('Action is not defined in action model.');
    }
  }

  GetDisableAction(): any {
    return false;
  }
}
